<template lang="pug">
v-container(fluid px-0 fill-height class=" tw-items-start tw-content-start tw-overflow-x-hidden tw-bg-blueGray-lighten-5")
  kubiqa-website-themes-theme-g-components-shared-top-navigation(appBarBg="theme-g-header-container")
  v-row(justify="center")
    v-col(cols="12" class="tw-w-auto tw-m-0 tw-pa-4  tw-pl-5 ")
      v-row
        v-col(cols="5" class="tw-relative")
          div(class="tw-rounded-md tw-overflow-hidden theme-g-gallery-large")
            v-img(:src="photos[0].src.original" aspect-ratio="1.1")
          div(class="tw-absolute tw-z-10 tw-right-0 tw-bottom-0 tw-pb-6 tw-pr-8")
            v-btn(color="#E8C855" class="tw-mr-2 " block elevation="0")
              span(class="tw-text-blueGray-darken-3") View Photos
        v-col(cols="7")
          v-row
            v-col(cols="6")
              div(class="theme-g-gallery-small")
                v-img(:src="photos[1].src.original" aspect-ratio="1.1" class="tw-w-full tw-object-cover tw-rounded")
            v-col(cols="6")
              div(class="theme-g-gallery-small")
                v-img(:src="photos[2].src.original" aspect-ratio="1.1" class="tw-w-full tw-object-cover tw-rounded")
          v-row(align="end")
            v-col(cols="6")
              div(class="theme-g-gallery-small")
                v-img(:src="photos[3].src.original" aspect-ratio="1.1" class="tw-w-full tw-object-cover tw-rounded")
            v-col(cols="6")
              div(class="theme-g-gallery-small")
                v-img(:src="photos[4].src.original" aspect-ratio="1.1" class="tw-w-full tw-object-cover tw-rounded")

  v-row(justify="space-around" class="tw-pt-8 tw-px-10 ")
    v-col
      v-row(no-gutters justify="center" class="d-flex tw-relative tw-z-10")
        v-col(cols="12")
          v-container(class="tw-py-8")
            v-row
              v-col(cols="auto")
                div(class="tw-rounded tw-px-3  tw-py-2 theme-g-cta-background")
                  span(class="tw-text-blueGray-darken-3 tw-font-bold") For {{ this.$faker().random.arrayElement(['Rent', 'Sale']) }}
            v-row
              v-col
                span(class="tw-text-3xl tw-font-bold") {{ this.$faker().lorem.sentence(6) }}
              v-col(cols="auto")
                span(class=" tw-text-3xl tw-font-bold") ${{ this.$faker().finance.amount(10000, 100000, 0) }}
            v-row(no-gutters align="center" justify="start" class="tw-pt-2 tw--ml-1 tw-pb-2")
              v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                div(class="tw-w-6 tw-h-6 tw-flex ")
                  v-icon(color=" blue-grey" class="tw-mx-auto") mdi-map-marker-outline
              v-col(cols="auto" class=" tw-text-center")
                span(class="tw-ml-1 tw-text-xl tw-font-medium") {{ this.$faker().address.county() }}, {{ this.$faker().address.stateAbbr() }}

      v-row(dense align="center" justify="start" class="tw-py-2 tw-pt-3 tw-border-t  tw-border-blueGray-lighten-4")
        v-col(cols="auto" class="tw-mr-2")
          v-row(no-gutters align="center" justify="center")
            v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
              div
                v-icon(large color="#E8C855" class="tw-mx-auto") mdi-bed-outline
            v-col(cols="auto" class=" tw-text-center")
              span(class="tw-ml-1 tw-font-bold tw-text-lg") {{ this.$faker().datatype.number({ min: 1, max: 4 }) }} Beds
        v-col(cols="auto" class="tw-mr-2")
          v-row(no-gutters align="center" justify="center")
            v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
            div
              v-icon(large color="#E8C855" class="tw-mx-auto") mdi-shower
            v-col(cols="auto" class=" tw-text-center")
              span(class="tw-ml-1 tw-font-bold tw-text-lg") {{ this.$faker().datatype.number({ min: 1, max: 4 }) }} Bath

        v-col(cols="auto" class="tw-mr-2")
          v-row(no-gutters align="center" justify="center")
            v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
            div
              v-icon(large color="#E8C855" class="tw-mx-auto") mdi-arrow-all
            v-col(cols="auto" class=" tw-text-center")
              span(class="tw-ml-1 tw-font-bold tw-text-lg") {{ this.$faker().datatype.number({ min: 200, max: 800 }) }} m<sup>2</sup>
      v-row
        v-col(cols="" class="")
          v-container(fluid p-0 class=" tw-rounded")
            v-row
              v-col(class="")
                span(class="tw-text-2xl tw-font-bold") Description
            v-row
              v-col
                p
                  span(class="tw-text-base tw-font-medium tw-leading-relaxed") {{ this.$faker().lorem.paragraphs(2) }}
                p
                  span(class="tw-text-base tw-font-medium tw-leading-relaxed") {{ this.$faker().lorem.paragraphs(3) }}

          v-container(fluid p-0 class=" tw-border-t  tw-border-blueGray-lighten-4 ")
            v-row(class="tw-pt-4")
              v-col(class="")
                span(class="tw-text-2xl tw-font-bold") Detail
            v-row
              v-col
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds

              v-col
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
              v-col
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
                div(class="tw-py-2")
                  span(class=" tw-font-bold tw-mr-2 ") Bedrooms:
                  span 4 beds
          div(class="tw-py-4")
          v-container(fluid p-0 class=" tw-border-t  tw-border-blueGray-lighten-4 ")
            v-row(class="tw-pt-4")
              v-col(class="")
                span(class="tw-text-2xl tw-font-bold") Amenities
            v-row
              v-col
                div(class="tw-py-2")
                  div(class="  tw-w-6 tw-h-6 tw-inline-block tw-text-center ")
                    v-icon(color="#E8C855" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 tw-font-medium ") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class="tw-w-6 tw-h-6 tw-inline-block tw-text-center")
                    v-icon(color="#E8C855" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 tw-font-medium") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class="tw-w-6 tw-h-6 tw-inline-block tw-text-center")
                    v-icon(color="#E8C855" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 tw-font-medium") {{ this.$faker().commerce.productName() }}
              v-col
                div(class="tw-py-2")
                  div(class="tw-w-6 tw-h-6 tw-inline-block tw-text-center")
                    v-icon(color="#E8C855" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 tw-font-medium") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class="tw-w-6 tw-h-6 tw-inline-block tw-text-center")
                    v-icon(color="#E8C855" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 tw-font-medium") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class="tw-w-6 tw-h-6 tw-inline-block tw-text-center")
                    v-icon(color="#E8C855" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 tw-font-medium") {{ this.$faker().commerce.productName() }}
              v-col
                div(class="tw-py-2")
                  div(class="tw-w-6 tw-h-6 tw-inline-block tw-text-center")
                    v-icon(color="#E8C855" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 tw-font-medium") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class="tw-w-6 tw-h-6 tw-inline-block tw-text-center")
                    v-icon(color="#E8C855" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 tw-font-medium") {{ this.$faker().commerce.productName() }}
                div(class="tw-py-2")
                  div(class="tw-w-6 tw-h-6 tw-inline-block tw-text-center")
                    v-icon(color="#E8C855" class="tw-mt-1") mdi-check
                  span(class="tw-ml-2 tw-font-medium") {{ this.$faker().commerce.productName() }}
          div(class="tw-py-4")
          v-container(fluid p-0 class=" tw-border-t  tw-border-blueGray-lighten-4 ")
            v-row(class="tw-pt-4")
              v-col(class="")
                span(class="tw-text-2xl tw-font-bold") Location
            v-row
              v-col
                kubiqa-misc-map

    v-col(cols="3")
      v-container(class="tw-bg-blueGray-darken-2 tw-rounded tw-overflow-hidden")
        v-row(align="center" class="  tw-h-16")
          v-col(class=" ")
            span(class=" tw-font-bold tw-text-3xl tw-text-white") Contact
        v-row
          v-col(class="tw-bg-blueGray-darken-2")
            v-row
              v-col
                v-text-field(label="Your name" outlined background-color="blue-grey darken-3" class="tw-rounded ")
                v-text-field(label="Your phone" outlined background-color="blue-grey darken-3" class="tw-rounded")
                v-text-field(label="Your email" outlined background-color="blue-grey darken-3" class="tw-rounded")
                v-textarea(
                  height="220"
                  outlined
                  background-color="blue-grey darken-3"
                  class="tw-rounded"
                  hide-details
                  no-resize
                  color="white"
                  placeholder="I'm interested in this property. Please send me additional information."
                )
                v-btn(
                  x-large
                  @click="method"
                  block
                  color="#E8C855"
                  elevation="0"
                  class="tw-mt-6"
                )
                  span(class="tw-font-bold tw-text-2xl tw-text-blueGray-darken-3") Send
  v-row(class="tw-pt-24")
    v-col

  kubiqa-website-themes-theme-g-components-shared-footer
</template>

<script>
export default {
  data() {
    return {
      photos: [],
    };
  },
  created() {
    this.fakePhotos();
  },
  methods: {
    fakePhotos() {
      this.$store.dispatch('properties/getPexelGallery').then((response) => {
        this.photos = response;
      });
    },
  },
};
</script>

<style lang="scss">
.theme-g-cta-background {
  background-color: #e8c855;
}
.theme-g-gallery-large {
  height: 56vh;
  overflow: hidden;
  border-radius: 10px;
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

.theme-g-gallery-small {
  height: calc(26vh + 3px);
  overflow: hidden;
  border-radius: 10px;
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}
</style>
